import { useState } from "react";
type Props<T> = {
  onComplete: (data: T) => void;
  onError?: (error: { message: string }) => void;
};
export const useAsync = () => {
  const [isLoading, setLoading] = useState(false);
  const [error, setHasError] = useState<undefined | { message: string }>();

  const execute = async <T,>({ onComplete, onError }: Props<T>, fn: () => Promise<T>) => {
    try {
      setLoading(true);
      setHasError(undefined);
      const response = await fn();
      console.log(response);
      setLoading(false);
      onComplete?.(response);
      //   return response;
    } catch (error) {
      const err = error as Error;
      const message = { message: `En feil har oppstått: ${err?.message || ""}` };
      setHasError(message);
      setLoading(false);
      onError?.(message);
    }
    return null;
  };

  return { isLoading, error, execute };
};
